// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SpeedLaws__container___zTZvu {
    display: flex;
    flex-direction: column;
    width: 60rem;
    height: 62.9rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.SpeedLaws__container___zTZvu .Table-CellsRow:hover {
    cursor: pointer;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.SpeedLaws__container___zTZvu .TableHeader-Cell:hover .TableCell-Wrapper {
    background-color: unset;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.SpeedLaws__container___zTZvu .TableHeader-Row .TableCell::after {
    visibility: hidden;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.SpeedLaws__container___zTZvu .TableCell:first-of-type .TableCell-Wrapper {
    padding-left: var(--space-s);
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.SpeedLaws__container___zTZvu .TableCell:last-of-type .TableCell-Wrapper {
    padding-right: var(--space-s);
}

.SpeedLaws__header___JEhar {
    border-bottom: 0.1rem solid var(--color-bg-border);
}

.SpeedLaws__titleCell___hyq9s {
    text-transform: initial;
}
`, "",{"version":3,"sources":["webpack://./src/core/modules/Modals/SpeedLawsModal/SpeedLaws.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,eAAe;AACnB;;AAEA,uEAAuE;AACvE;IACI,eAAe;AACnB;;AAEA,uEAAuE;AACvE;IACI,uBAAuB;AAC3B;;AAEA,uEAAuE;AACvE;IACI,kBAAkB;AACtB;;AAEA,uEAAuE;AACvE;IACI,4BAA4B;AAChC;;AAEA,uEAAuE;AACvE;IACI,6BAA6B;AACjC;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    width: 60rem;\n    height: 62.9rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.Table-CellsRow):hover {\n    cursor: pointer;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TableHeader-Cell):hover :global(.TableCell-Wrapper) {\n    background-color: unset;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TableHeader-Row) :global(.TableCell)::after {\n    visibility: hidden;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TableCell):first-of-type :global(.TableCell-Wrapper) {\n    padding-left: var(--space-s);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.container :global(.TableCell):last-of-type :global(.TableCell-Wrapper) {\n    padding-right: var(--space-s);\n}\n\n.header {\n    border-bottom: 0.1rem solid var(--color-bg-border);\n}\n\n.titleCell {\n    text-transform: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SpeedLaws__container___zTZvu`,
	"header": `SpeedLaws__header___JEhar`,
	"titleCell": `SpeedLaws__titleCell___hyq9s`
};
export default ___CSS_LOADER_EXPORT___;
